type NaverWcsCommand = () => void;

const pendingCommands: NaverWcsCommand[] = [];
let isWcsScriptLoaded = false;

/**
 * wcslog.js(afterInteractive) 로드 후 실행을 보장하는 커맨드 큐.
 * 로드 전 호출은 적재되고 onLoad flush 때 순서대로 실행된다 — gtag dataLayer와 같은 패턴.
 * 반환된 cleanup으로 미실행 커맨드를 취소할 수 있다.
 */
export const runOnNaverWcsReady = (command: NaverWcsCommand) => {
  if (isWcsScriptLoaded) {
    command();

    return () => {};
  }

  pendingCommands.push(command);

  return () => {
    const commandIndex = pendingCommands.indexOf(command);

    if (commandIndex !== -1) {
      pendingCommands.splice(commandIndex, 1);
    }
  };
};

/**
 * 선언형 트리거를 걸 수 없는 지점(mutation onSuccess 등)에서 전환을 쏜다.
 * 렌더 트리에 붙일 수 있으면 `NaverCtsTransTrigger`를 쓴다.
 */
export const trackNaverCtsConversion = (
  transOption: Parameters<Window['wcs']['trans']>[0],
) =>
  runOnNaverWcsReady(() => {
    window.wcs.trans(transOption);
  });

export const flushNaverWcsCommands = () => {
  isWcsScriptLoaded = true;

  while (pendingCommands.length > 0) {
    pendingCommands.shift()?.();
  }
};
